module.exports = __webpack_public_path__ + "static/media/undercover_00002.34b58405.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/undercover_00002.png
// module id = 62
// module chunks = 0